import React, { Component } from 'react'
import { Link } from 'react-router'
import moment from 'moment'
import { Col, Row, Button } from 'react-bootstrap'
import Newsletter from '../../../Newsletter'
import NoteItem from './item'
import NoteList from './list'
import ActionBar from './actionBar'
import PaginationButtons from '../../../../containers/Sections/Propiedades/pagination'
import { translate } from "react-translate"

@translate("Notes")
export default class Notes extends Component {

  constructor (props) {
    super(props)

    this.state = {
      words: false
    }

    this.handleChangeNewsletter = this.handleChangeNewsletter.bind(this);
  }

  handleChangeNewsletter(id) {
    this.props.loadNotes(id)
  }

  componentWillMount() {
    window.scrollTo(0,0)
    this.props.loadNotes(this.props.params.id)
    this.props.loadSectors()
  }

  _renderDate(date){
    moment.locale('es');
    var m = moment(date)
    let day = moment(m).format('MMMM')
    let year = moment(m).format('YYYY')
    return (
      <span>{day} {year}</span>
    )
  }

  handleChangeProperty(value) {
    this.props.onSelectSector(value, this.props.params.id)
  }

  render () {

    let id = parseInt(this.props.params.id)

    const { notes, newsletter, newslettersList, loadNewsletters, loadNotes, sectors, onSelectSector, searchNotesByForm, t } = this.props

    function checkNewsletterList () {
      if (newslettersList.length == 0){
        loadNewsletters()
      }
    }

    checkNewsletterList()

    var list = newslettersList.slice(0, 7);
    
    let baseUrl = window.location.origin;
    let detailUrl = window.location.href;
    let newsletterUrl = baseUrl + '/newsletters';

    return (
      <div id="top" name="top" className="notes-container">
        <ol className="route-info hidden-xs" itemScope itemType="http://schema.org/BreadcrumbList">
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <a href={ baseUrl } itemProp="item" itemType="http://schema.org/Thing">
              <span itemProp="name"><small>{t("Informacion_Novedades")}</small></span>
              <meta itemProp="position" content="1" />
            </a>
          </li>
          
          <i className="fa fa-angle-right"></i>
          
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <a href={ newsletterUrl } itemProp="item" itemType="http://schema.org/Thing">
              <span itemProp="name"><small>{t("Newsletters")}</small></span>
              <meta itemProp="position" content="2" />
            </a>
          </li>
          
          <i className="fa fa-angle-right"></i>
          
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <a href={ detailUrl } itemProp="item" itemType="http://schema.org/Thing">
              <span itemProp="name"><small>{this._renderDate(newsletter.date)}</small></span>
              <meta itemProp="position" content="3" />
            </a>
          </li>
        </ol>
        
        { (newsletter) ? (
            <div className="action-bar">
              <ActionBar newsletter={newsletter} sectors={sectors} onSelectSector={(value) => this.handleChangeProperty(value)} searchNotesByForm={searchNotesByForm}/>
            </div>
          ) : ''
        }
        { (list) ? (
          <div className="last-imis-list hidden-xs">
            <ul>
              {list.map((item, index) =>
                <li key={index} onClick={() => this.handleChangeNewsletter(item.id)}>
                  <Link to={'/newsletters/' + item.slug} className={(item.slug === id) ? 'active-imi' : ''}>{this._renderDate(item.date)}</Link>
                </li>
              )}
            </ul>
          </div>
          ) : ''
        }
        <NoteList notes={notes} />
        <PaginationButtons />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Newsletter/Notes/index.js